import {Badge, Dialog, Fab, IconButton, Slide, Tooltip, Typography} from "@mui/material";
import {Close, ShoppingCart} from "@mui/icons-material"
import {theme} from "../../Tema";
import '../estilos.css'
import {useProductosCarrito} from "../Funcionamiento/Hooks/useProductosCarrito";
import {Grid} from "@mui/system";
import {forwardRef, useState} from "react";
import Dialogo_Carrito from "../Dialogos/Dialogos_Carrito";


export const useCarritoFlotante = () => {
    const {productos} = useProductosCarrito()
    const [open, setOpen] = useState(false)

    const abrir = () => {
        setOpen(true)
    }

    const cerrar = () => {
        setOpen(false)
    }

    const Transition = forwardRef(function Transition(props, ref) {
        return <Slide direction="down" ref={ref} {...props} />;
    });


    const CarritoFlotante = () => {
        return (
            <>
                <Tooltip title={'Ver Carrito'}>
                    <Fab
                        onClick={() => abrir()}
                        className={'blob'}
                        size={'large'}
                        sx={{
                            display: productos.length > 0 ? 'true' : 'none',
                            position: 'fixed',
                            bottom: '5%',
                            right: '4%',
                            p: 5,
                            backgroundColor: theme.palette.primary.main,
                            '&:hover': {backgroundColor: theme.palette.info.main}
                        }}>
                        <Badge badgeContent={productos.length} color="secondary">
                            <ShoppingCart sx={{width: 32, height: 32, fill: '#fff'}}/>
                        </Badge>

                    </Fab>
                </Tooltip>

                <Dialog open={open} keepMounted TransitionComponent={Transition} fullWidth
                        maxWidth={'xs'}
                        scroll={'body'}
                        sx={{m: -2}}>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={12}
                        sx={{p: 2, overflowX: 'hidden'}}
                    >

                        <Grid container size={10}
                              sx={{justifyContent: 'flex-start', px: 0, mt: -1.5}}>
                            <Typography sx={{fontWeight: 500, fontSize: 18}}>Carrito de compras</Typography>
                        </Grid>

                        <Grid container size={2} sx={{justifyContent: 'flex-end', pr: 0, mt: -1}}>
                            <IconButton onClick={() => cerrar()} sx={{mr: -1}}>
                                <Close></Close>
                            </IconButton>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Dialogo_Carrito cerrar={cerrar}/>
                        </Grid>


                    </Grid>

                </Dialog>

            </>

        )
    }

    const Carrito = () =>{

        return(
            <Dialog open={open} keepMounted TransitionComponent={Transition} fullWidth
                    maxWidth={'xs'}
                    scroll={'body'}
                    sx={{m: -2}}>


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={12}
                    sx={{p: 2, overflowX: 'hidden'}}
                >

                    <Grid container size={10}
                          sx={{justifyContent: 'flex-start', px: 0, mt: -1.5}}>
                        <Typography sx={{fontWeight: 500, fontSize: 18}}>Carrito de compras</Typography>
                    </Grid>

                    <Grid container size={2} sx={{justifyContent: 'flex-end', pr: 0, mt: -1}}>
                        <IconButton onClick={() => cerrar()} sx={{mr: -1}}>
                            <Close></Close>
                        </IconButton>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Dialogo_Carrito cerrar={cerrar}/>
                    </Grid>


                </Grid>

            </Dialog>
        )
    }


    return {
        CarritoFlotante,
        abrir,
        Carrito
    }
}